export default class Utils {
  static formatDate(date: Date): string {
    return new Intl.DateTimeFormat('en-US').format(date);
  }

  static parseDate(dateString: string): Date {
    return new Date(dateString);
  }

  static debounce<T extends (...args: unknown[]) => void>(func: T, delay: number): (...args: Parameters<T>) => void {
    let timeout: ReturnType<typeof setTimeout>;
    return (...args: Parameters<T>) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), delay);
    };
  }

  // theme
  static toggleTheme(): void {
    document.body.classList.toggle('dark-mode');
    localStorage.setItem('theme', document.body.classList.contains('dark-mode') ? 'dark' : 'light');
  }

  static getCurrentTheme(): string {
    return localStorage.getItem('theme') || 'light';
  }

  static setTheme(theme: 'dark' | 'light'): void {
    if (theme === 'dark') {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
    localStorage.setItem('theme', theme);
  }
}
